module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-row specific-template-item"
  }, [_c('div', {
    staticClass: "table-col specific-template-item specific-template-step overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.action.human_step) + " / " + _vm._s(_vm.flow.actions.length))]), _c('div', {
    staticClass: "table-col table-col-200 specific-template-item specific-template-name overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.template.name || '-'))]), _c('div', {
    staticClass: "table-col specific-template-item specific-template-category"
  }, [(_vm.template.category_name) ? _c('span', {
    staticClass: "label label-default"
  }, [_vm._v(_vm._s(_vm.template.category_name))]) : _c('span', [_vm._v("-")])]), _c('div', {
    staticClass: "table-col table-col-200 specific-template-item specific-template-body overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.template.subject || '-'))]), _c('div', {
    staticClass: "table-col table-col-collapsed specific-template-item specific-template-actions show action-button"
  }, [_c('span', {
    staticClass: "plain-btn-edit",
    class: {
      orange: _vm.edited
    },
    on: {
      "click": function($event) {
        return _vm.editSpecificTemplate($event)
      }
    }
  })]), _c('div', {
    staticClass: "table-col table-col-collapsed specific-template-item specific-template-actions show"
  }, [(_vm.edited && _vm.current_user.can_manage_templates) ? _c('span', {
    staticClass: "glyphicon glyphicon-trash clickable-element",
    on: {
      "click": _vm.destroySpecificTemplate
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5853593d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/specific_templates/list_item.vue
// module id = 1132
// module chunks = 1